var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnOff001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_39_Buttons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m377.509 13.89h-243.018c-61.36 0-111.219 49.936-111.219 111.22 0 61.36 49.86 111.219 111.219 111.219h243.017c61.36 0 111.219-49.859 111.219-111.219.001-61.284-49.859-111.22-111.218-111.22zm0 207.307h-243.018c-52.961 0-96.087-43.125-96.087-96.087s43.126-96.088 96.087-96.088h243.017c52.961 0 96.087 43.126 96.087 96.088s-43.125 96.087-96.086 96.087z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.509,
    cy: 125.11,
    r: 71.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.712 117.549h-115.631c-4.182 0-7.566 3.384-7.566 7.566s3.384 7.566 7.566 7.566h115.632c4.182 0 7.566-3.384 7.566-7.566s-3.385-7.566-7.567-7.566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.509 275.672h-243.018c-61.36 0-111.219 49.935-111.219 111.219 0 61.36 49.86 111.219 111.219 111.219h243.017c61.36 0 111.219-49.859 111.219-111.219.001-61.284-49.859-111.219-111.218-111.219zm0 207.306h-243.018c-52.961 0-96.087-43.05-96.087-96.087 0-52.961 43.126-96.087 96.087-96.087h243.017c52.961 0 96.087 43.125 96.087 96.087.001 53.037-43.125 96.087-96.086 96.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.535 386.891c0 39.191-31.853 71.12-71.044 71.12s-71.044-31.929-71.044-71.12 31.853-71.044 71.044-71.044 71.044 31.853 71.044 71.044z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.919 379.349h-115.631c-4.182 0-7.566 3.384-7.566 7.566s3.384 7.566 7.566 7.566h115.632c4.182 0 7.566-3.384 7.566-7.566s-3.385-7.566-7.567-7.566z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOff001);
export default __webpack_public_path__ + "static/media/on_off_001.5cafd5525bac4ec3d61c97debd3d9f59.svg";
export { ForwardRef as ReactComponent };